<h2>Hantera bilagor</h2>
<p>
    För dessa saker behöver du skicka in bilagor tillsammans med din ansökan. <ng-container *ngIf="isAuthorized">Du kan
        ladda upp bilagorna direkt
        och/eller skicka in dem per post.</ng-container>
</p>

<app-reveal *ngIf="degree" title="Examensbevis för behörighetsgivande examen">
    Bifoga något av följande
    <ul>
        <li>Examensbevis, utbildningsbevis eller motsvarande över avslutad utbildning. I regel krävs en lärar- eller
            förskollärarutbildning. </li>
        <li>En behörighetsförklaring utfärdad av Skolöverstyrelsen. </li>
    </ul>
</app-reveal>

<app-reveal *ngIf="specialTeacher" title="Examensbevis för din speciallärar-/specialpedagogexamen">
    Bifoga något av följande
    <ul>
        <li>Ett examensbevis, utbildningsbevis eller motsvarande för speciallärarexamen.</li>
        <li>Ett behörighetsbevis utfärdat av Högskoleverket.</li>
        <li>Ett intyg över motsvarande utländsk examen.</li>
    </ul>
</app-reveal>

<ng-container *ngFor="let basis of bases">
    <app-reveal [title]="basis.header">
        För följande behörigheter
        <ul>
            <li *ngFor="let qual of basis.qualifications">{{qual}}</li>
        </ul>
        {{basis.text}}
        <br>
        <a *ngIf="basis.type === 'VOCATIONAL_SKILLS_NOT_BY_TEACHING'" class="text-link" target="_blank"
            href="/assets/Blankett - Validering av yrkeskunskaper 2023-02-27.pdf">Blankett - validering av
            yrkeskunskaper</a>
    </app-reveal>
</ng-container>


<ng-container *ngIf="isAuthorized">
    <label class="text-standard" for="delivery-method-radio-group">Välj hur du vill bifoga dina bilagor. Du kan inte ladda upp bilagor större än 2 MB. Om du har bilagor som är större än 2 MB måste du välja något av de två sista alternativen.</label>
    <app-form-group id="delivery-method-radio-group" data-test-id="delivery-method-radio-group">
        <app-radio-button *ngFor="let method of deliveryMethods" [control]="deliveryMethod" [value]="method.value">
            Jag
            vill
            {{method.description}}</app-radio-button>
        <span *ngIf="error" class="text-error text-small">{{error}}</span>
    </app-form-group>

    <app-attachment-selector *ngIf="files"></app-attachment-selector>
</ng-container>

<app-form-group *ngIf="mail">
    <label class="text-standard" for="mail-desc">Skicka in bilagor per post</label>
    <div id="mail-desc">
        <p>
            Bilagorna bifogar du till din pappersansökan som du skickar in till Skolverket.
            <br/>
            Skulle du vilja komplettera din ansökan med ytterligare handlingar vid ett senare skede behöver du ett
            försättsblad. Detta försättsblad gör att vi automatiskt kan skanna bilagorna och koppla dem till ditt
            ärende. Du får försättsbladet som en PDF-fil i ditt bekräftelsemejl när Skolverket har registrerat ditt
            ärende.
        </p>
    </div>
</app-form-group>
